<app-modal-refactor
  [size]="'lg'"
  [showImage]="false"
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]=true
  >
  <div body class="containerError">
    <h1 *ngIf="codeError == '204131-1'" class="tittleError">{{ "errorMsjDestination.error.msjDestination.title" | translate }}</h1>
    <p *ngIf="codeError == '204131-1'" class="fs-28px descError" >
      {{ "errorMsjDestination.error.msjDestination.subtitle" | translate }}</p>
      <h1 *ngIf="codeError == '204131'" class="tittleError">{{ "errors.pnrLookup.reservationNoFound.title" | translate }}</h1>
    <p *ngIf="codeError == '204131'" class="fs-28px descError"   [innerHTML]="'errors.pnrLookup.reservationNoFound.text' | translate">
      </p>
    <div *ngIf="codeError == '204131-1'" class="errorsBtns">
        <button class="btnsErrorDestination" (click)="actionBtnBoarding()" >
          <img src="./assets/fonts/fontawesome/svgs/Scancon.png">
          <span>{{ "errorMsjDestination.error.rebrand.scan" | translate }}</span>
      </button>
    </div>
    <div *ngIf="codeError == '204131-1'" class="errorsBtns">
      <button class="btnsErrorDestinationPnr" (click)="actionBtnReservation()" >
        <img src="./assets/fonts/fontawesome/svgs/Search.svg">
        <span>{{ "errorMsjDestination.error.rebrand.pnr" | translate }}</span>
    </button>
    </div>
    <div *ngIf="codeError == '204131'" class="errorsBtnsPnr">
      <button class="error-confirm-btn" (click)="actionBtnReservation()">{{ "OK" }}</button>
    </div>
    <div *ngIf="codeError == '202020'" class="errorsBtnsPnr">
      <button class="error-confirm-btn" (click)="close()">{{ "OK" }}</button>
    </div>
  </div>
</app-modal-refactor>
